<template>
	<!-- <div id="app">
	<h1>Hello World from Vue!</h1>
	</div> -->
	<profile-layout :fo_config="fo_config" :settingsConfig="settingsConfig" v-model:activeTab="activeTab">
		<MesRendezVous v-if="activeTab === 'rdv'" :rdvsToCome="this.rdvsToCome" @cancel-rdv="cancelRdv"></MesRendezVous>
		<Historique v-if="activeTab === 'history'" :rdvsFinished="this.rdvsFinished"></Historique>
        <MesInformations v-if="activeTab === 'userInfo'" :form="this.fields"></MesInformations>
	</profile-layout>
</template>

<script>
	import ProfileLayout from "./Profile/ProfileLayout.vue";
	import MesRendezVous from "./Profile/MesRendezVous.vue";
	import Historique from "./Profile/Historique.vue";
    import MesInformations from "./Profile/MesInformations.vue";
    import { toast } from "bulma-toast";
	import axios from 'axios'
    import SignUp from "./Profile/SignUp.vue";
    import AuthPage from "./Profile/AuthPage.vue";
    export default {
		name : 'Profile',
		props : ['fo_config', "settingsConfig"],
		components : {ProfileLayout, MesRendezVous, Historique, MesInformations, SignUp, AuthPage},
        computed: {
            config () {
                return this.$page.props.config
            },
            user() {
                return this.$page.props.auth.user?.client?.[0]
            },
            redirected(){
                return this.fo_config && (this.fo_config['redirected'] == 1);
            },
            redirect_params(){
                if(!this.redirected){
                    return '';
                }
                let url = window.location.href;
                // let params = url.substring(url.lastIndexOf('/')+1).replace('times','');
                let params = url.split('?',2)[1];
                return params+'&redirected=1';     
        }  
        },
		data() {
			return {
				activeTab: 'rdv',
				rdvsToCome: [],
				rdvsFinished: [],
                fields: [],
			}
		},
		watch: {
  			activeTab(newVal) {
    			console.log('Active tab changed to:', newVal)
  			}
		},
		methods: {
            cancelRdv(rdvToCancel) {
                console.log('emit received', rdvToCancel)
                axios.delete('/rdv/'+ rdvToCancel).then(response => {
                    this.rdvsToCome = this.rdvsToCome.filter(rdv => rdv.rdv_id != rdvToCancel)
                    toast({
                        message: 'Votre rendez-vous a bien été annulé.',
                        type: 'is-success',
                        duration: 3000,
                        pauseOnHover: true
                    })
                }).catch(err => {
                    toast({
                        message: err?.response?.data?.message || 'Une erreur a empeché la suppression du rendez-vous.',
                        type: 'is-danger',
                        duration: 5000,
                        pauseOnHover: true
                    })
                })
            },
			getDuration(rdv) {
                if (!rdv.prestation.display_duration || rdv.prestations.find(prestation => !prestation.display_duration)) return 'Non communiquée'
                let duration = rdv.prestations.reduce((accumulator, prestation) => accumulator += prestation.duration, 0)
                let hours = Math.floor(duration / 60)
                let minutes = duration % 60
                if (minutes < 10 && minutes != 0) minutes = '0' + minutes
                let str = ''
                if (hours) str += hours + 'h'
                if (minutes) str += minutes + ' min.'
            return str
            },
            getPrestations(rdv) {
                return rdv.prestations.map(prestation => prestation.fo_name || prestation.bo_name).join(', ')
            },
            getPrice (rdv) {
                if (!rdv.prestation.display_price || rdv.prestations.find(prestation => !prestation.display_price)) return 'Non communiqué'
                return rdv.prestations.reduce((accumulator, prestation) => accumulator += prestation.price ?? 0, 0)
            },
            getStatus (rdv) {
                if (rdv.state == 0) return 'En attente'
                else if (rdv.state == 1) return 'Venu'
                else if (rdv.state == -1) return 'Pas venu'
                else return ''
            },
            getRdvs() {
                    axios.get('client/rdvs').then(response => {
                    this.rdvsFinished = response.data.rdvsPasse.map(rdv => {
                        rdv.prestations = [rdv.prestation, ...rdv.prestations_sup]
                        rdv.status = this.getStatus(rdv)
                        rdv.duration = this.getDuration(rdv)
                        rdv.prestations_list = this.getPrestations(rdv)
                        rdv.price = this.getPrice(rdv)
                        if (rdv.location == null){
                            rdv.location = rdv?.agenda?.location
                        }
                        return rdv
                    }).sort((a, b) => (new Date(a.start_date).getTime() < new Date(b.start_date).getTime()))
                    this.rdvsToCome = response.data.rdvsVenir.map(rdv => {
                        rdv.prestations = [rdv.prestation, ...rdv.prestations_sup]
                        rdv.prestations_list = this.getPrestations(rdv)
                        return rdv
                    }).sort((a, b) => (new Date(a.start_date).getTime() > new Date(b.start_date).getTime()))
                })
            },
            getFields () {
                axios.get('/client/informations').then(response => {
                    this.fields = response.data.sort((a, b) => a.position > b.position)
                })
            },
        },
		mounted() {
            this.getRdvs();
            this.getFields();
            // console.log(this.config)
        }
	}
</script>
